<script setup lang="ts">
import { computed } from 'vue';
import { formatCnae } from '@/utils/formatters';

const props = defineProps<{
    code: string | undefined | null;
}>();

const formattedCode = computed(() => formatCnae(props.code || ''));

const link = computed(() => {
    if (!props.code) return '#';
    const cleanCode = props.code.replace(/\D/g, '');
    return `https://concla.ibge.gov.br/busca-online-cnae.html?view=subclasse&tipo=cnae&versao=10.1.0&subclasse=${cleanCode}&chave=0500301`;
});
</script>

<template>
    <span v-if="!code" class="text-gray-400">N/A</span>
    <a
        v-else
        :href="link"
        target="_blank"
        rel="noopener noreferrer"
        class="hover:text-blue-800 hover:underline transition-colors"
        title="Ver no IBGE CONCLA"
    >
        {{ formattedCode }}
    </a>
</template>
